import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Button, TextField, Typography, Grid, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Auth } from 'aws-amplify';
import { useStore } from '@mcn-platform/models';
const AccountSettings = () => {
    const { currentCustomer } = useStore();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    if (!currentCustomer) {
        return null;
    }
    const handleSubmit = async () => {
        setIsSubmit(true);
        setSuccess('');
        setError('');
        if (currentPassword === '' || newPassword === '' || newPassword !== repeatPassword) {
            return;
        }
        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(currentUser, currentPassword, newPassword);
            setIsSubmit(false);
            setSuccess('Profile is successfully updated.');
        }
        catch (err) {
            console.log('err', err);
            if (err instanceof Error) {
                setError(err.message);
            }
        }
    };
    return (_jsxs(Box, { sx: { width: '100%' }, children: [_jsx(Grid, { container: true, spacing: 3, children: _jsxs(Grid, { item: true, md: 6, sm: 12, children: [_jsx(Typography, { variant: "subtitle1", fontWeight: 700, sx: { mb: '3px' }, children: "User Name" }), _jsx(Typography, { variant: "h6", sx: { mb: 3, color: '#007bad' }, children: currentCustomer.email }), _jsx(Typography, { variant: "subtitle1", fontWeight: 700, sx: { mb: 1 }, children: "Change Password" }), _jsx(TextField, { fullWidth: true, helperText: "Field cannot be empty.", label: "Current Password", name: "currentPassword", onChange: (ev) => setCurrentPassword(ev.target.value), required: true, type: "password", value: currentPassword, error: isSubmit && currentPassword === '', variant: "outlined", InputLabelProps: {
                                sx: { color: (t) => (t.portal.global.font.color) },
                            }, InputProps: {
                                sx: {
                                    '& fieldset': {
                                        borderColor: (t) => (t.portal.global.font.color),
                                    },
                                },
                            } }), _jsx(TextField, { fullWidth: true, helperText: "Field cannot be empty.", label: "New Password", name: "newPassword", onChange: (ev) => setNewPassword(ev.target.value), required: true, value: newPassword, type: "password", variant: "outlined", error: isSubmit && newPassword === '', InputLabelProps: {
                                sx: { color: (t) => (t.portal.global.font.color) },
                            }, InputProps: {
                                sx: {
                                    '& fieldset': {
                                        borderColor: (t) => (t.portal.global.font.color),
                                    },
                                },
                            } }), _jsx(TextField, { fullWidth: true, helperText: repeatPassword === '' ? 'Field cannot be empty.' : "New passwords don't match.", label: "Repeat New Password", name: "repeatPassword", onChange: (ev) => setRepeatPassword(ev.target.value), required: true, value: repeatPassword, type: "password", error: isSubmit && (newPassword === '' || newPassword !== repeatPassword), variant: "outlined", InputLabelProps: {
                                sx: { color: (t) => (t.portal.global.font.color) },
                            }, InputProps: {
                                sx: {
                                    '& fieldset': {
                                        borderColor: (t) => (t.portal.global.font.color),
                                    },
                                },
                            } })] }) }), error && _jsx(Typography, { color: "secondary", children: error }), success && _jsx(Typography, { color: "primary", children: success }), _jsx(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'flex-start',
                }, children: _jsx(Button, { className: "primary", onClick: handleSubmit, children: "Submit" }) })] }));
};
export default observer(AccountSettings);
//# sourceMappingURL=AccountSettings.js.map